import { render, staticRenderFns } from "./GroupDropdown.vue?vue&type=template&id=85d4c166&"
import script from "./GroupDropdown.vue?vue&type=script&lang=js&"
export * from "./GroupDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports